import React from "react";
import { Trans } from "@lingui/macro";
import { useHistory } from "react-router-dom";
import { typeSidebarData } from "../constants";
import { ROUTS } from "../../../../../routs/routs";
import { LogoutIcon } from "@heroicons/react/outline";
import { getCookie } from "../../../../../utils/utils";
import { useDispatch, useSelector } from "react-redux";
import { selectSystemLogin } from "../../../../../model/system/selectors";
import { logoutSagaAC } from "../../../../../model/system/systemActionCreators";

export type typeSidebarLogout = {
  menuObject: typeSidebarData;
  setMenuObject: React.Dispatch<React.SetStateAction<typeSidebarData>>;
};

export const SidebarLogout: React.FC<typeSidebarLogout> = ({
  menuObject,
  setMenuObject,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const login = useSelector(selectSystemLogin);

  const onLogoutHandler = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    document.cookie = `tindaRemoteToken=; path=/; domain=${process.env.REACT_APP_DOMAIN}; max-age=-1`;
    document.cookie = `tindaRemoteRefreshToken=; path=/; domain=${process.env.REACT_APP_DOMAIN}; max-age=-1`;
    document.cookie = `tindaRemoteMerchant=; path=/; domain=${process.env.REACT_APP_DOMAIN}; max-age=-1`;

    document.cookie = `tindaToken=; path=/; domain=${process.env.REACT_APP_DOMAIN}; max-age=-1`;
    document.cookie = `tindaRefreshToken=; path=/; domain=${process.env.REACT_APP_DOMAIN}; max-age=-1`;

    history.push(ROUTS.COMMODITY_PRODUCTS_DASHBOARD);

    setMenuObject(
      menuObject.map((item, index) => {
        return index ? { ...item, current: false } : { ...item, current: true };
      }),
    );

    dispatch(logoutSagaAC());
  };

  const remoteMerchantId = getCookie("tindaRemoteMerchant");

  return (
    <div className="flex-shrink-0 flex flex-col bg-primary-800 p-4">
      {remoteMerchantId ? (
        <div className="mb-4 px-3 py-2 bg-red-600 rounded-md text-white text-center">
          <Trans>Remember to end your remote control session</Trans>
        </div>
      ) : null}

      <a
        href="/"
        onClick={onLogoutHandler}
        className="flex-shrink-0 w-full group block"
      >
        <div className="flex items-center">
          <div>
            <LogoutIcon className="inline-block h-5 w-5 rounded-full flex-shrink-0 text-white" />
          </div>
          <div className="ml-1">
            <p className="text-sm font-medium text-white">{login}</p>
          </div>
        </div>
      </a>
    </div>
  );
};
